import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-dialog-end-quarter',
    templateUrl: './dialog-end-quarter.component.html',
    styleUrls: ['./dialog-end-quarter.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslocoModule]
})
export class DialogEndQuarterComponent {
  public titleKey: string
  public contentKey: string
  public buttonKey: string
  public isOvertimeButtonEnabled = false

  constructor() {
    const data = inject<{
    quarter: number;
}>(MAT_DIALOG_DATA);

    switch (data.quarter) {
      case 1:
        this.titleKey = "endQuarter.1stQuarterTitle"
        this.contentKey = "endQuarter.1stQuarterContent"
        this.buttonKey = "endQuarter.1stQuarterBtn"
        break
      case 2:
        this.titleKey = "endQuarter.2ndQuarterTitle"
        this.contentKey = "endQuarter.2ndQuarterContent"
        this.buttonKey = "endQuarter.2ndQuarterBtn"
        break
      case 3:
        this.titleKey = "endQuarter.3rdQuarterTitle"
        this.contentKey = "endQuarter.3rdQuarterContent"
        this.buttonKey = "endQuarter.3rdQuarterBtn"
        break
      case 4:
        this.titleKey = "endQuarter.endGameTitle"
        this.contentKey = "endQuarter.endGameContent"
        this.buttonKey = "endQuarter.endGameBtn"
        this.isOvertimeButtonEnabled = true
        break
      case 5:
        this.titleKey = "endQuarter.endGameTitle"
        this.contentKey = "endQuarter.endGameContent"
        this.buttonKey = "endQuarter.endGameBtn"
        break
      default:
        throw new Error("Invalid quarter: " +  data.quarter)
    }
  }
}
